import {localizeDate, normalizeTimePart} from "../format";

export const getScheduleDateText = (arrival, language) => {
    const startDate = localizeDate(arrival.startDate, language);
    const endOrTime = arrival.isShowBookingTime
        ? normalizeTimePart(arrival.startTime)
        : `- ${localizeDate(arrival.endDate, language)}`;

    return `${startDate} ${endOrTime}`;
}